import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { Toaster } from 'sonner';
import PublicLayout from './layouts/PublicLayout';
import ReaderLayout from './layouts/ReaderLayout';
import AdminLayout from './layouts/AdminLayout';
import { UserProtected, AdminProtected } from './components/ProtectedRoute';

import LandingPage from './pages/LandingPage';
import GenericPage from './pages/GenericPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ChatPage from './pages/ChatPage';
import EbookPage from './pages/EbookPage';
import PurchasePage from './pages/PurchasePage';
import OnboardingPage from './pages/OnboardingPage';

import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import UsersPage from './pages/admin/UsersPage';
import PurchasesPage from './pages/admin/PurchasesPage';
import PagesListPage from './pages/admin/PagesListPage';
import PageEditorPage from './pages/admin/PageEditorPage';
import EETrainingPage from './pages/admin/EETrainingPage';

// We use createBrowserRouter (a "data router") instead of <BrowserRouter> so that
// hooks like useBlocker (used in PageEditorPage for the unsaved-changes guard)
// work. The route structure mirrors the previous <Routes> tree exactly.
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Public */}
      <Route path="/" element={<PublicLayout><LandingPage /></PublicLayout>} />
      <Route path="/p/:slug" element={<PublicLayout><GenericPage /></PublicLayout>} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* Reader (auth required) */}
      <Route path="/dashboard" element={<UserProtected><ReaderLayout><DashboardPage /></ReaderLayout></UserProtected>} />
      <Route path="/chat" element={<UserProtected requireAccess><ReaderLayout><ChatPage /></ReaderLayout></UserProtected>} />
      <Route path="/ebook" element={<UserProtected requireAccess><ReaderLayout><EbookPage /></ReaderLayout></UserProtected>} />
      <Route path="/purchase" element={<UserProtected><PurchasePage /></UserProtected>} />
      <Route path="/onboarding" element={<UserProtected><OnboardingPage /></UserProtected>} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="/admin/dashboard" element={<AdminProtected><AdminLayout><AdminDashboardPage /></AdminLayout></AdminProtected>} />
      <Route path="/admin/users" element={<AdminProtected><AdminLayout><UsersPage /></AdminLayout></AdminProtected>} />
      <Route path="/admin/purchases" element={<AdminProtected><AdminLayout><PurchasesPage /></AdminLayout></AdminProtected>} />
      <Route path="/admin/pages" element={<AdminProtected><AdminLayout><PagesListPage /></AdminLayout></AdminProtected>} />
      <Route path="/admin/page-editor" element={<AdminProtected><AdminLayout><PageEditorPage /></AdminLayout></AdminProtected>} />
      <Route path="/admin/ee-training" element={<AdminProtected><AdminLayout><EETrainingPage /></AdminLayout></AdminProtected>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  )
);

export default function App() {
  return (
    <>
      <Toaster theme="dark" toastOptions={{ style: { background: '#141414', border: '1px solid #c4a14444', color: '#fff' } }} />
      <RouterProvider router={router} />
    </>
  );
}
